import Vue from 'vue'
import Router from 'vue-router'
import utils from '@/utils/utils'
//备份原型对象已有的push|replace方法
let push = Router.prototype.push;
let replace = Router.prototype.replace;
//重写VueRouter.prototype原型对象的push|replace方法
Router.prototype.push = function (location) {
  //调用push方法且篡改push方法内部this指向->vueRouter类的实例
  push.call(this, location, () => { }, () => { });
}
Router.prototype.replace = function (location) {
  //调用push方法且篡改push方法内部this指向->vueRouter类的实例
  replace.apply(this, [location, () => { }, () => { }]);
}
Vue.use(Router)
// 在路由加载的时候首次进来要按需加载路由，首页加载慢的问题，不要使用import换成require
export const constantRouteMap = [
  {
    path: '/',
    redirect: utils.isMobile() ? '/h5' : '/home'
  },
  // 首页
  {
    path: '/home',
    component: resolve => require(['@/views/index/index'], resolve),
    name: 'index',
    meta: {
      title: '健康教育平台',
      showAi: true
    }
  },
  {
    path: '/ai',
    component: resolve => require(['@/views/ai'], resolve),
    name: 'ai',
    meta: {
      title: '健康教育平台',
      showAi: true
    }
  },
  {
    path: '/open',
    component: resolve => require(['@/views/open'], resolve),
    name: 'open',
    meta: {
      title: '健康教育平台'
    }
  },
  {
    path: '/news',
    component: resolve => require(['@/views/news/news'], resolve),
    name: 'news',
    meta: {
      title: '最新资讯',
      showAi: true
    }
  },
  {
    path: '/news/detail',
    component: resolve => require(['@/views/news/detail'], resolve),
    name: 'newsDetail',
    meta: {
      title: '最新资讯详情'
    }
  },
  {
    path: '/file',
    component: resolve => require(['@/views/news/file'], resolve),
    name: 'file',
    meta: {
      title: '政策文件',
      showAi: true
    }
  },
  {
    path: '/file/detail',
    component: resolve => require(['@/views/news/detail'], resolve),
    name: 'fileDetail',
    meta: {
      title: '政策文件详情'
    }
  },
  {
    path: '/resource',
    component: resolve => require(['@/views/news/resource'], resolve),
    name: 'resource',
    meta: {
      title: '其他资源',
      showAi: true
    }
  },
  {
    path: '/resource/detail',
    component: resolve => require(['@/views/news/detail'], resolve),
    name: 'resourceDetail',
    meta: {
      title: '其他资源详情'
    }
  },
  {
    path: '/safe',
    component: resolve => require(['@/views/news/safe'], resolve),
    name: 'safe',
    meta: {
      title: '安全报道',
      showAi: true
    }
  },
  {
    path: '/safe/detail',
    component: resolve => require(['@/views/news/detail'], resolve),
    name: 'safeDetail',
    meta: {
      title: '安全报道详情'
    }
  },
  {
    path: '/course',
    component: resolve => require(['@/views/course/list'], resolve),
    name: 'course',
    meta: {
      title: '课程中心',
      showAi: true
    }
  },
  {
    path: '/course/online-details',
    component: resolve => require(['@/views/course/online/details'], resolve),
    name: 'courseDetails',
    meta: {
      title: '在线课程'
    }
  },
  {
    path: '/course/online-detailsToken',
    component: resolve => require(['@/views/course/online/detailsToken'], resolve),
    name: 'courseDetails',
    meta: {
      title: '在线课程'
    }
  },
  {
    path: '/course/online-learning',
    component: resolve => require(['@/views/course/online/learning'], resolve),
    name: 'courseLearning',
    meta: {
      title: '在线课程'
    }
  },
  {
    path: '/course/plan-details',
    component: resolve => require(['@/views/course/plan/details'], resolve),
    name: 'coursePlan',
    meta: {
      title: '学习计划'
    }
  },
  {
    path: '/course/plan-detailsToken',
    component: resolve => require(['@/views/course/plan/detailsToken'], resolve),
    name: 'coursePlan',
    meta: {
      title: '学习计划'
    }
  },
  {
    path: '/course/practice-details',
    component: resolve => require(['@/views/course/practice/details'], resolve),
    name: 'coursePractice',
    meta: {
      title: '实践课程'
    }
  },
  {
    path: '/course/practice-detailsToken',
    component: resolve => require(['@/views/course/practice/detailsToken'], resolve),
    name: 'coursePractice',
    meta: {
      title: '实践课程'
    }
  },
  {
    path: '/food',
    component: resolve => require(['@/views/food/index'], resolve),
    name: 'course',
    meta: {
      title: '带量食谱',
      showAi: true
    }
  },
  {
    path: '/health',
    component: resolve => require(['@/views/health/index'], resolve),
    name: 'health',
    meta: {
      title: '健康管理',
      showAi: true
    }
  },
  {
    path: '/health/student-health',
    component: resolve => require(['@/views/health/studentHealth'], resolve),
    name: 'studentHealth',
    meta: {
      title: '健康管理'
    }
  },
  {
    path: '/health/school-health',
    component: resolve => require(['@/views/health/schoolHealth'], resolve),
    name: 'schoolHealth',
    meta: {
      title: '健康管理'
    }
  },
  {
    path: '/health/country-health',
    component: resolve => require(['@/views/health/countryHealth'], resolve),
    name: 'countryHealth',
    meta: {
      title: '健康管理'
    }
  },
  {
    path: '/h5',
    name: "首页",
    component: resolve => require(['@/h5/home/index.vue'], resolve),
    meta: {
      title: '健康教育平台'
    }
  },
]
const router = new Router({
  mode: 'history', // 根绝环境变量来区分是打包成APP还是网页版查看,history和mode模式
  routes: constantRouteMap
})

router.beforeEach((to,from,next)=>{ //beforeEach是router的钩子函数，在进入路由前执行
  if(to.meta.title){ //判断是否有标题
    document.title = to.meta.title
  }
  next()  //执行进入路由，如果不写就不会进入目标页
})

export default router
